import {
    LOAD_SETTINGS,
    SET_SETTINGS,
    EDIT_GENERAL_SETTINGS,
    EDIT_CALENDER_SETTINGS,
    EDIT_NOTIFICATION_SETTINGS,
    EDIT_INVOICES_SETTINGS,
  } from './types';
import {BACKEND_API} from "../../config/middleware";
import API from "../../config/api-url";

export const setSettings = data => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: SET_SETTINGS,
            method: 'put',
            url: API.CUSTOMER_SETTINGS,
            data
        },
    )
});

export const LoadSettings = () => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: LOAD_SETTINGS,
            method: 'get',
            url: API.CUSTOMER_SETTINGS,
        },
    )
});

export const editGeneralSettings = (data) => ({
    type: BACKEND_API,
    payload: Object.assign({
      type: EDIT_GENERAL_SETTINGS,
      method: "put",
      url: API.GENERAL_SETTINGS,
      data,
    }),
  });
  
  export const editCalenderSettings = (data) => ({
    type: BACKEND_API,
    payload: Object.assign({
      type: EDIT_CALENDER_SETTINGS,
      method: "put",
      url: API.CALENDER_SETTINGS,
      data,
    }),
  });
  
  export const editNotificationSettings = (data) => ({
    type: BACKEND_API,
    payload: Object.assign({
      type: EDIT_NOTIFICATION_SETTINGS,
      method: "put",
      url: API.NOTIFICATION_SETTINGS,
      data,
    }),
  });
  
  export const editInvoiceSettings = (data) => ({
    type: BACKEND_API,
    payload: Object.assign({
      type: EDIT_INVOICES_SETTINGS,
      method: "put",
      url: API.INVOICE_SETTINGS,
      data,
    }),
  });